import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Policy } from '@components/templates/marketplace';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function PolicyPage() {
    const { pageKey } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t(`policy-component.${pageKey}.metatags.title`),
        description: t(`policy-component.${pageKey}.metatags.description`),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.policy.replace(':pageKey', `${pageKey}`),
        index: false,
    });

    return <Policy />;
}
